import { v4 as uuidv4 } from "uuid";
export class DetailModel {
    constructor() {
        this.id = uuidv4();
        this.masterId = uuidv4();
    }
}
export default class ListMaster extends DetailModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
